import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Subscription, catchError, tap } from 'rxjs';

import { Cargo } from '@app/core/models/questionario-cargo';
import { MessageService } from 'primeng/api';
import { OnlyNumbersDirective } from '@core/directives/onlyNumbers.directive';
import { OportunidadesApiService } from '@app/core/services/oportunidades-api.service';
import { QuestionarioCargoApiService } from '@app/tabelasAdministrativas/services/questionario-cargo-api.service';
import { UiService } from '@app/core/services/ui.service';
import { ValidateHelper } from '@app/core/helpers/validate.helper';

@Component({
  selector: 'sgp-manter-questionario-cargo',
  templateUrl: './manter-questionario-cargo.component.html',
  providers: [MessageService]
})
export class ManterQuestionarioCargoComponent implements OnInit, AfterViewInit , OnDestroy{

  @Input() item!: Cargo;
	@Output() itemSalvo: EventEmitter<Cargo> = new EventEmitter<Cargo>();
  @Output() fecharModal: EventEmitter<any> = new EventEmitter<any>();
	@ViewChild('elNomeCampo') elNomeCampo!: ElementRef;

  placeholderConcurso = 'Selecione o concurso.';
  placeholderCargo = 'Selecione o órgão.';

  concursos?: any[];
  orgaoSelecionado?: any;
	erroNomeCargo = false;
  erroCodigoCargo = false;
  erroConcurso = false;
  erroNomeOrgao = false;
  erroOrgao = false;
  contemErros = false;
	mensagemErroNome = '';
  mensagemErroCodigoCargo = '';
  mensagemErroConcurso = '';
  mensagemErroOrgao = '';
  submetido = false;
  subscriptions: Subscription[] = [];
  codigoCargoStr = '';

	constructor(
      protected cargoApiService: QuestionarioCargoApiService, 
      private oportunidadesService: OportunidadesApiService, 
      private messageService: MessageService,
      private ui: UiService, 
      private validate: ValidateHelper) {}

  ngOnInit(): void {
    this.carregarDados();
  }
  
  ngAfterViewInit(): void {
		this.elNomeCampo.nativeElement.focus();
	}

  ngOnDestroy(): void {
		this.subscriptions.forEach(subscription => subscription.unsubscribe());
	}
  
	salvar() {
  this.submetido = true;
  this.resetErrosValidacao();
   this.validarPreenchimento();
		if (!this.contemErros) {
			this.itemSalvo.emit(this.item);
      this.submetido = false;
		}
	}

	cancelar() {
		this.item = new Cargo();
    this.submetido = false;
    this.orgaoSelecionado = undefined;
    this.resetErrosValidacao();
    this.fecharModal.emit(true);
	}

  selecionarConcurso(event: any): void {
    const idConcurso = event.value;

    if (idConcurso != null) {
      this.item.idConcurso = idConcurso;
    } else {
      this.item.idConcurso = undefined;
    }
  }

  atualizarOrgao(event: any) {
    if (event && event.code != null) {
      this.orgaoSelecionado = event;
      this.item.codigoOrgao = this.orgaoSelecionado.code;
    } else {
      this.orgaoSelecionado = undefined;
      this.item.codigoOrgao = undefined;
    }
	}

  formatarCodigoCargo() {
    this.erroCodigoCargo = false;
		let valor = this.codigoCargoStr;
		if (valor && /^\d+$/.test(valor)) {
			let numero = parseInt(valor, 10);
			if (numero >= 0 && numero <= 999999) {
				let formatado = numero.toString().padStart(6, '0');
				this.codigoCargoStr = formatado;
				return;
			}
		}
		this.codigoCargoStr = '';
	}

  private carregarDados() {
    // Filtrar por concursos na situacao 'Em Rascunho'
    this.cargoApiService.carregarConcursos();
    this.subscriptions.push(
      this.cargoApiService.concursos$!.subscribe(res => {
        this.concursos = this.cargoApiService.tratarDadosConcurso(res.items, 'RAS');
      })
    );
  

    if (this.item?.codigoOrgao) {
      const codigoOrgao = this.item?.codigoOrgao.toString();
      this.subscriptions.push(
        this.oportunidadesService
            .consultarOrgao(codigoOrgao)
            .pipe(
                tap((orgao) => {
                  if (orgao) {
                    this.orgaoSelecionado = { name: codigoOrgao + ' - ' + orgao.sigla + ' - ' + orgao.nome, code: orgao.codigoSiape };
                  }
                }),
                catchError(err => {
                  this.messageService.clear();
		              this.messageService.add(this.ui.criarMensagem('error', '',  err.error.message));
                  throw err;
                })
              ).subscribe()
          );
    }

    if (this.item?.codigoCargo) {
      this.codigoCargoStr = this.item.codigoCargo.toString().padStart(6, '0');
    }
  }

	private validarPreenchimento(): void {
		const nomeTrim = this.item.nomeCargo?.trim();
		if (this.validate.isEmBranco(nomeTrim)) {
			this.erroNomeCargo = true;
			this.mensagemErroNome = 'Campo obrigatório';
		} else if (nomeTrim && nomeTrim.length < 3) {
			this.erroNomeCargo = true;
			this.mensagemErroNome = 'O nome do cargo deve possuir pelo menos três caracteres';
		} else {
			this.item.nomeCargo = nomeTrim;
			this.erroNomeCargo = false;
		}
    this.contemErros = this.contemErros || this.erroNomeCargo;

    this.item.codigoCargo = 0;
    if (this.validate.isEmBranco(this.codigoCargoStr)) {
      this.erroCodigoCargo = true;
      this.mensagemErroCodigoCargo = 'O código do cargo deve ser um valor numérico maior que zero de até seis dígitos';
    } else {
      this.item.codigoCargo = parseInt(this.codigoCargoStr, 10);
    }
    if (this.item.codigoCargo! < 1 || this.item.codigoCargo! > 999999) {
      this.mensagemErroCodigoCargo = 'O código do cargo deve ser um valor numérico maior que zero de até seis dígitos';
      this.erroCodigoCargo = true;
    }
    this.contemErros = this.contemErros || this.erroCodigoCargo;

    const idConcurso = this.item.idConcurso;
    if (this.validate.isEmBranco(idConcurso)) {
      this.erroConcurso = true;
      this.mensagemErroConcurso = 'O concurso é obrigatório';
    }
    this.contemErros = this.contemErros || this.erroConcurso;

    const codigoOrgao = this.item.codigoOrgao;
    if (this.validate.isEmBranco(codigoOrgao)) {
      this.erroOrgao = true;
      this.mensagemErroOrgao = 'O órgão é obrigatório';
    }
    this.contemErros = this.contemErros || this.erroOrgao;
	}

  private resetErrosValidacao(): void {
    this.erroNomeCargo = false;
    this.erroCodigoCargo = false;
    this.erroConcurso = false;
    this.erroOrgao = false;
    this.contemErros = false;
    this.mensagemErroNome = '';
    this.mensagemErroCodigoCargo = '';
    this.mensagemErroConcurso = '';
    this.mensagemErroOrgao = '';
  }
}
